import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {ButtonGroup} from 'shells/button-group/button-group';
import {TrashRegularIcon} from 'shells/icon/svg/trash-regular-icon';

import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {ExternalMeetingFragment} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {trackMeetingLoggedAsNewActivity, trackLoggingFlowInitiated} from './helpers';
import {LogActivityButton} from './log-activity-button';
import type {ExternalServiceTypeFrontend} from './types';

type Props = {
    cell: {
        value: ExternalMeetingFragment;
    };
    onAssociateMeetingWithActivity: (id: string) => Promise<any>;
    onRemoveMeeting: (id: string) => Promise<any>;
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
    isProcessing: boolean;
};

export function ButtonCell(props: Props) {
    return (
        <ButtonGroup style={{height: 'auto'}}>
            {!props.isProcessing && (
                <LogActivityButton
                    onClick={() => {
                        if (props.cell.value.activity) {
                            trackLoggingFlowInitiated(props.serviceType, 'list');

                            appHistory.replace({
                                ...appHistory.location,
                                hash: `/${props.cell.value.activity.id}`,
                                state: {modal: true},
                            });

                            return Promise.resolve();
                        }

                        trackMeetingLoggedAsNewActivity(props.serviceType);

                        return props
                            .onAssociateMeetingWithActivity(props.cell.value.id)
                            .then((result) => {
                                const activityId =
                                    result &&
                                    result.data &&
                                    result.data.externalMeetingAssociateWithActivity &&
                                    result.data.externalMeetingAssociateWithActivity.activity &&
                                    result.data.externalMeetingAssociateWithActivity.activity.id;

                                if (activityId) {
                                    appHistory.replace({
                                        ...appHistory.location,
                                        hash: `/${activityId}`,
                                        state: {modal: true},
                                    });
                                }
                            });
                    }}
                />
            )}
            <ActionMenu
                options={[
                    {
                        label: 'Delete call',
                        variant: 'destructive',
                        icon: <TrashRegularIcon size={16} wrapWithDiv={false} />,
                        handleSelect: () => {
                            props.onRemoveMeeting(props.cell.value.id);
                        },
                    },
                ]}
                padding='horizontal'
                size='tiny'
            />
        </ButtonGroup>
    );
}
